import React from 'react'
import Hero from './components/hero'
import BydoAI from './components/bydoAI'
import Launch from './components/launch'
import Innovation from './components/innovation'
import Application from './components/application'
import Appbuild from './components/appBuild'
import StackCard from './components/stackCard'
 
function Home() {
  return (
    <div>
      <Hero />
      <StackCard />
      <BydoAI />
      <Launch />
      <Innovation />
      <Application />
      <Appbuild />
    </div>
  )
}

export default Home
